import script from "./ProjectI18nModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectI18nModal.vue?vue&type=script&setup=true&lang=js"

import "./ProjectI18nModal.vue?vue&type=style&index=0&id=3429ae97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3429ae97"]])

export default __exports__